import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { CallForPriceButtonLocalize } from './call-for-price-button-localize';

/** Shown in place of a price or the quantity stepper when an item is call for pricing. A label styled as a button: it has no action. */
@Component({
  selector: 'ideal-call-for-price-button',
  imports: [MatButtonModule, MatIconModule, MatTooltip],
  standalone: true,
  templateUrl: './call-for-price-button.component.html',
  styleUrl: './call-for-price-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallForPriceButtonComponent {
  protected readonly localization = CallForPriceButtonLocalize;
  private readonly _labelTooltip = viewChild<MatTooltip>('labelTooltip');

  protected onClick() {
    // Only reachable icon-only (see the stylesheet), where the label shows in a tooltip instead. Show, not
    // toggle: hover (or a tap that also fires mouseenter) may already have opened it. A tap elsewhere closes it.
    this._labelTooltip()?.show(0);
  }
}
